import { format, isValid, parse } from 'date-fns';

/** Preserve date-only values; timestamps with a timezone are not calendar dates. */
export function parseAnimalBirthDate(value: string | Date | null): Date {
  if (value instanceof Date && isValid(value)) return value;
  if (typeof value === 'string') {
    for (const inputFormat of [
      'yyyy-MM-dd',
      'dd/MM/yyyy',
      'dd/MM/yyyy HH:mm:ss',
    ]) {
      const date = parse(value, inputFormat, new Date(2000, 0, 1));
      if (isValid(date) && format(date, inputFormat) === value) return date;
    }
  }
  throw new Error("La date de naissance de l'animal est absente ou invalide.");
}
